module.exports = __webpack_public_path__ + "img/03.b44268fd.png";